import { baseRequest } from '@/utils/request'

const request = (url, ...arg) =>  baseRequest(`/biz/c/companyinfo/${url}`, ...arg)
const request2 = (url, ...arg) =>  baseRequest(`/biz/c/companyInfoHrModifyApply/${url}`, ...arg)
/**
 * 企业基础信息接口管理
 *
 */
export default {
	// 分页
	page(data) {
		return request('page', data, 'get')
	},
	// 详情
	detail(data) {
		return request('detail', data, 'get')
	},
	// 提交表单 edit为true时为编辑，默认为新增
	submitForm(data, id) {
        return request(id ? 'edit' : 'add', data)
	},
	// 删除
	delete(data) {
		return request('delete', data)
	},
	// 列表
	userList(data) {
		return request('userList', data, 'get')
	},
	currentHrApplyData(data){
		return request2('currentHrApplyData', data, 'get')
	},
	addOrEditCompanyApply(data){
		return request2('addOrEdit', data)
	},
	// 完善企业信息
	addWaitVerificationCompanyInfo(data,id){
		return baseRequest(`/auth/c/addWaitVerificationCompanyInfo`, data)
	},
	 checkCompanyExist (data){
		return baseRequest(`/biz/c/companyinfo/checkCompanyExist`, data)
	}
}
